<!--
 * @Descripttion: 
 * @Author: Chen Zhi
 * @Date: 2021-09-23 10:13:59
 * @LastEditors: chenzhi
 * @LastEditTime: 2022-12-09 16:08:17
-->
<template>
  <div class="message-page" @click="goDownload">
    <!-- 引导 -->
    <div class="model" v-if="isShow" @click="isShow = false">
      <div class="guidance">
        <div class="guid-icon"></div>
        <div class="title">
          {{ $t('1.点击右上角的') }}“ <span class="icon-guide-more"></span> ”
        </div>
        <div class="title">{{ $t('2.在浏览器中打开') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { getPlatform } from '@/utils'
@Component({
  name: 'Message'
})
export default class Message extends Vue {
  // 是否显示引导
  isShow = false

  pla = getPlatform()

  created() {
    const { aplus_queue } = window
    aplus_queue.push({
      action: 'aplus.record',
      arguments: ['Invitee_enters_ jump_page', 'CLK', {}]
    })
  }

  //跳转链接
  downLoadUrl(url) {
    this.isShow = false
    if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
      // const loadDateTime = new Date()
      // window.location.href = 'allo.ios.app://' //schema链接或者universal link
      // window.setTimeout(function() {
      //   //如果没有安装app,便会执行setTimeout跳转下载页
      //   const timeOutDateTime = new Date()
      //   if (timeOutDateTime - loadDateTime < 5000) {
      //     window.location.href = 'https://itunes.apple.com/app/1664635935' //ios下载页面
      //   } else {
      //     window.close()
      //   }
      // }, 500)
      return
    }
    window.location.href = 'qingshu://tel.top/home/callshow?select=0'
    let timer = null
    const openTime = Date.now()
    const success = () => {
      console.log('调起APP')
      clearInterval(timer)
    }

    timer = setInterval(() => {
      if (document.hidden) {
        console.log('调起APP')
        success()
      } else if (Date.now() - openTime > 2500) {
        const { aplus_queue } = window
        aplus_queue.push({
          action: 'aplus.record',
          arguments: ['preemptive_download_experience', 'CLK', {}]
        })
        clearInterval(timer)
        // 打开下载页
        const a = document.createElement('a')
        a.href = url
        a.click()
      }
    }, 500)
    document.addEventListener('visibilitychange', success)
  }

  // 下载App
  goDownload() {
    // const { aplus_queue } = window
    // aplus_queue.push({
    //   action: 'aplus.record',
    //   arguments: ['click_the_landing_page', 'CLK', {}]
    // })
    if (this.pla === 'weixin' || this.pla === 'qq') {
      this.isShow = true
    } else {
      this.downLoadUrl(process.env.VUE_APP_InviteDownloadUrl)
    }
  }
}
</script>

<style lang="scss" scoped>
.message-page {
  width: 100%;
  height: 100vh;
  text-align: center;
  @include bg-image('newInvite/pic@2x');
}

.model {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 999;
  .guidance {
    position: absolute;
    top: 10px;
    right: 10px;
    text-align: right;

    .guid-icon {
      display: inline-block;
      width: 61px;
      height: 61px;
      @include bg-image('newInvite/icon_yd@2x');
      // float: right;
    }
    .icon-guide-more {
      display: inline-block;
      width: 3px;
      height: 11px;
      @include bg-image('newInvite/pic_gd@2x');
    }

    .title {
      text-align: left;
      font-size: 15px;
      color: #f9f9f9;
      line-height: 18px;
      margin-bottom: 10px;
    }
  }
}
</style>
